// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.document-card--grid {
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.06);
  min-width: 180px;
  max-height: 180px;
  display: flex;
  flex-direction: column;
  position: relative;
}
.document-card--grid:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}
.document-card--grid:focus-visible {
  outline: 2px solid var(--category-color, #757575);
  outline-offset: 2px;
}
.document-card--selected {
  border-color: var(--ion-color-primary, #3880ff);
  box-shadow: 0 0 0 1px var(--ion-color-primary, #3880ff);
}
.document-card__checkbox {
  position: absolute;
  top: 4px;
  left: 4px;
  z-index: 2;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.document-card__checkbox ion-checkbox {
  --size: 18px;
  margin: 0;
}
.document-card__list-checkbox {
  margin: 0 4px 0 0;
  --size: 20px;
}
.document-card__preview {
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  position: relative;
  overflow: hidden;
}
.document-card__icon {
  width: 40px;
  height: 40px;
  object-fit: contain;
}
.document-card__thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.document-card__thumb-list {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}
.document-card__body {
  padding: 8px 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.document-card__title {
  font-family: var(--font);
  font-weight: 600;
  font-size: 12px;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3;
}
.document-card__meta {
  font-family: var(--font);
  font-weight: 400;
  font-size: 10px;
  margin: 0;
  opacity: 0.7;
  display: flex;
  align-items: center;
  gap: 4px;
}
.document-card__dot {
  opacity: 0.5;
}
.document-card--list {
  --padding-start: 8px;
}
.document-card--list.document-card--selected {
  --background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.06);
}
.document-card--list .document-card__avatar {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  border-radius: 8px;
  overflow: hidden;
}
.document-card--list .document-card__avatar img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.document-card--list ion-label h2 {
  font-family: var(--font);
  font-weight: 600;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.document-card--list ion-label p {
  font-family: var(--font);
  font-weight: 400;
  font-size: 11px;
  opacity: 0.7;
}

@media (prefers-reduced-motion: reduce) {
  .document-card--grid {
    transition: none;
  }
  .document-card--grid:hover {
    transform: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/documents/document-card/document-card.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;AACF;;AAGE;EACE,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qDAAA;EACA,yCAAA;EACA,qCAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;AAAJ;AAEI;EACE,2BAAA;EACA,0CAAA;AAAN;AAGI;EACE,iDAAA;EACA,mBAAA;AADN;AAKE;EACE,+CAAA;EACA,uDAAA;AAHJ;AAME;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAJJ;AAMI;EACE,YAAA;EACA,SAAA;AAJN;AAQE;EACE,iBAAA;EACA,YAAA;AANJ;AASE;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAPJ;AAUE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AARJ;AAWE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AATJ;AAYE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AAVJ;AAaE;EACE,iBAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAXJ;AAcE;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;AAZJ;AAeE;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAbJ;AAgBE;EACE,YAAA;AAdJ;AAiBE;EACE,oBAAA;AAfJ;AAiBI;EACE,oEAAA;AAfN;AAkBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;AAhBN;AAkBM;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAhBR;AAqBM;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AAnBR;AAsBM;EACE,wBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AApBR;;AA0BA;EACE;IACE,gBAAA;EAvBF;EAyBE;IACE,eAAA;EAvBJ;AACF","sourcesContent":[":host {\n  display: block;\n}\n\n.document-card {\n  &--grid {\n    background: #fff;\n    border-radius: 10px;\n    overflow: hidden;\n    cursor: pointer;\n    transition: transform 0.2s ease, box-shadow 0.2s ease;\n    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);\n    border: 1px solid rgba(0, 0, 0, 0.06);\n    min-width: 180px;\n    max-height: 180px;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n\n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);\n    }\n\n    &:focus-visible {\n      outline: 2px solid var(--category-color, #757575);\n      outline-offset: 2px;\n    }\n  }\n\n  &--selected {\n    border-color: var(--ion-color-primary, #3880ff);\n    box-shadow: 0 0 0 1px var(--ion-color-primary, #3880ff);\n  }\n\n  &__checkbox {\n    position: absolute;\n    top: 4px;\n    left: 4px;\n    z-index: 2;\n    background: rgba(255, 255, 255, 0.9);\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n\n    ion-checkbox {\n      --size: 18px;\n      margin: 0;\n    }\n  }\n\n  &__list-checkbox {\n    margin: 0 4px 0 0;\n    --size: 20px;\n  }\n\n  &__preview {\n    height: 90px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f5f5f5;\n    position: relative;\n    overflow: hidden;\n  }\n\n  &__icon {\n    width: 40px;\n    height: 40px;\n    object-fit: contain;\n  }\n\n  &__thumbnail {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  &__thumb-list {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 8px;\n  }\n\n  &__body {\n    padding: 8px 10px;\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n  }\n\n  &__title {\n    font-family: var(--font);\n    font-weight: 600;\n    font-size: 12px;\n    margin: 0;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    line-height: 1.3;\n  }\n\n  &__meta {\n    font-family: var(--font);\n    font-weight: 400;\n    font-size: 10px;\n    margin: 0;\n    opacity: 0.7;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  &__dot {\n    opacity: 0.5;\n  }\n\n  &--list {\n    --padding-start: 8px;\n\n    &.document-card--selected {\n      --background: rgba(var(--ion-color-primary-rgb, 56, 128, 255), 0.06);\n    }\n\n    .document-card__avatar {\n      width: 40px;\n      height: 40px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: #f5f5f5;\n      border-radius: 8px;\n      overflow: hidden;\n\n      img {\n        width: 100%;\n        height: 100%;\n        object-fit: contain;\n      }\n    }\n\n    ion-label {\n      h2 {\n        font-family: var(--font);\n        font-weight: 600;\n        font-size: 13px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n\n      p {\n        font-family: var(--font);\n        font-weight: 400;\n        font-size: 11px;\n        opacity: 0.7;\n      }\n    }\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .document-card--grid {\n    transition: none;\n\n    &:hover {\n      transform: none;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
